export const zoomToMapPosition = (map, target, zoomLevel = 16) => {
  if (!map || !target) return;

  map.panTo(target);
  const currentZoom = Number(map.getZoom());
  if (!Number.isFinite(currentZoom) || currentZoom < zoomLevel) {
    map.setZoom(zoomLevel);
  }
};
